"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var findPaletteByColor_1 = require("./findPaletteByColor");

var monochromePaletteKeys = ["darker", "dark", "base", "light", "lighter"];
var colorPaletteKeys = ["darkest"].concat(monochromePaletteKeys, ["lightest"]);

function isColorPalette(palette) {
  return Object.prototype.hasOwnProperty.call(palette, "darkest");
}

function getOffsetInPalette(offset, offsetDirection, color) {
  var palette = findPaletteByColor_1.findPaletteByColor(color);
  var effectiveOffset = offsetDirection === "lighter" ? offset : -offset;

  if (isColorPalette(palette)) {
    var index_1 = Object.keys(palette).findIndex(function (paletteKey) {
      return palette[paletteKey] === color;
    });
    return palette[colorPaletteKeys[Math.min(Object.keys(palette).length - 1, Math.max(0, index_1 + effectiveOffset))]];
  }

  var index = Object.keys(palette).findIndex(function (paletteKey) {
    return palette[paletteKey] === color;
  });
  return palette[monochromePaletteKeys[Math.min(Object.keys(palette).length - 1, Math.max(0, index + effectiveOffset))]];
}

exports.getOffsetInPalette = getOffsetInPalette;